<template>
  <el-table-column
    prop="is_order_id_required"
    sortable="custom"
    label="Megrendelésszám kötelező"
    show-overflow-tooltip
    min-width="230"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.is_customer && scope.row.is_order_id_required" type="success" size="small">Igen</el-tag>
      <el-tag v-if="scope.row.is_customer && !scope.row.is_order_id_required" type="danger" size="small">Nem</el-tag>
      <el-tag v-if="!scope.row.is_customer" type="info" size="small">Nem vevő</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_order_id_required',
  };
</script>
